import { z } from 'zod';
import { MetricRangeSchema, ConsoleInputSchema } from './web.js';
import { RequestParamsSchemas, SnapshotInputSchema } from './requests.js';
import { SoftwareFamilySchema } from './domain.js';
export const McpRequestIdInputSchema = z.object({ requestId: z.string().min(1) });
export const McpRequestTargetSchema = z.object({ serverId: z.string().min(1).optional() });
export const McpSoftwareVersionsInputSchema = z.object({
  family: SoftwareFamilySchema,
  snapshots: z.boolean().optional(),
});
export const McpServerInputSchema = z.object({ serverId: z.string().min(1) });
export const McpMetricsInputSchema = McpServerInputSchema.extend({ range: MetricRangeSchema.default('1h') });
export const McpLogsInputSchema = McpServerInputSchema.extend({ tail: z.number().int().min(1).max(2000).default(200) });
export const McpJobsInputSchema = z.object({
  serverId: z.string().optional(),
  limit: z.number().int().min(1).max(1000).default(100),
});
export const McpJobInputSchema = z.object({ jobId: z.string().min(1) });
export const McpOperationInputSchema = McpServerInputSchema.extend({ vm: z.boolean().optional() });
export const McpConsoleInputSchema = McpServerInputSchema.extend(ConsoleInputSchema.shape);
export const McpSnapshotInputSchema = McpServerInputSchema.extend(SnapshotInputSchema.shape);
const { regenerate_world: _regenerate, apply_edge: _edge, ...mcpParams } = RequestParamsSchemas;
export const McpRequestParamsSchemas = mcpParams;
export const defaultConsoleAllowlist = ['list', 'say', 'tps', 'mspt', 'tick query', 'whitelist list', 'save-all'];
export const McpAuditInputSchema = z.object({
  since: z.iso.datetime({ offset: true }).optional(),
  until: z.iso.datetime({ offset: true }).optional(),
  powerOnly: z.boolean().default(false),
  operation: z.string().max(100).optional(),
  target: z.string().max(100).optional(),
  via: z.enum(['web', 'mcp', 'system', 'agent']).optional(),
  limit: z.number().int().min(1).max(500).default(50),
});
export type McpAuditInput = z.infer<typeof McpAuditInputSchema>;
